import { render, staticRenderFns } from "./CountryFamilyAccount.vue?vue&type=template&id=10b5ae4b&scoped=true&"
import script from "./CountryFamilyAccount.vue?vue&type=script&lang=js&"
export * from "./CountryFamilyAccount.vue?vue&type=script&lang=js&"
import style0 from "./CountryFamilyAccount.vue?vue&type=style&index=0&id=10b5ae4b&prod&lang=css&"
import style1 from "./CountryFamilyAccount.vue?vue&type=style&index=1&id=10b5ae4b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5ae4b",
  null
  
)

export default component.exports